import { AlertMargin } from "App/global-style";
import { ContactUsAlert } from "Components/Form/Alert";
import { useTexts } from "Components/TextContext";
import { AlertTitle } from "Components/TextContext/commonComponentEnums";
import React from "react";
import { isConstructionYearFieldInvalid } from "../House/conditions";
import type {
  Props as ConstructionYearProps,
  ConstructionYearValue,
} from "./ConstructionYear";

type Props<T extends ConstructionYearValue> = Pick<
  ConstructionYearProps<T>,
  "formProps" | "errorMessage"
> & {
  marginBottom?: AlertMargin;
};

export const ConstructionYearError = <T extends ConstructionYearValue>({
  formProps,
  errorMessage,
  marginBottom,
}: Props<T>): React.ReactElement | null => {
  const { getText } = useTexts();
  if (isConstructionYearFieldInvalid(formProps.values.constructionYear)) {
    return (
      <ContactUsAlert
        description={errorMessage}
        title={getText(AlertTitle.CALL_US)}
        alertId="constructionYear"
        marginBottom={marginBottom}
      />
    );
  }
  return null;
};
